import React from 'react';
import './LpSection.css';

const LpSection = ({children}) => {
    return (
        <div className={"LpSection"}>
            {children}
        </div>
    );
};

export default LpSection;